export default "__VITE_ASSET__i3Frg6xW__"